import React from 'react'

export default ({ children}) => (
    <div className="card">
        {children}
    </div>
)